import { MessageDescriptor } from '@lingui/core';
import { msg } from '@lingui/core/macro';
import { ReviewClipKind } from 'modules/match-video/domain/interfaces';

/** Every clip kind the review knows, in the order the kind select lists them. */
export const REVIEW_CLIP_KINDS: readonly ReviewClipKind[] = ['goal', 'danger', 'other'];

export const REVIEW_CLIP_KIND_LABELS: Record<ReviewClipKind, MessageDescriptor> = {
  goal: msg`Гол`,
  danger: msg`Опасный момент`,
  other: msg`Без плашки`,
};

/**
 * Words at the start of a file name that set the clip kind, lower case, spaces between words. The first one of each
 * kind is the one the screen's hint shows first. Any other word — `other`, the kind is then chosen by hand.
 */
export const REVIEW_CLIP_NAME_WORDS: Record<Exclude<ReviewClipKind, 'other'>, readonly string[]> = {
  goal: ['goal', 'гол'],
  danger: ['danger', 'момент', 'опасный момент'],
};
